const translations = {
  ...window.rebuy_translations,
};

decodeHTML = (input) => {
  // If input is an object, process each string value
  if (typeof input === 'object' && input !== null) {
    return Object.entries(input).reduce((acc, [key, value]) => {
      acc[key] = typeof value === 'string' ? decodeHTML(value) : value;
      return acc;
    }, {});
  }

  // If input is a string containing HTML entities, decode it
  if (typeof input === 'string' && input.includes('&lt;')) {
    const tempElement = document.createElement('textarea');
    tempElement.innerHTML = input;
    return new DOMParser().parseFromString(tempElement.value, 'text/html').body.innerHTML;
  }

  // Return unchanged input if no processing needed
  return input;
};

updateSmartCartLanguage = () => {
  const smartCart = translations.smart_cart;

  const subscriptionTranslations = {
    upgrade: translations.widget.cart_switch_to_subscription,
    downgrade: translations.widget.downgrading_label,
    onetimeLabel: translations.widget.onetime_option_group_label,
    subscriptionLabel: translations.widget.subscription_option_group_label,
    upgradeLabel: translations.widget.upgrading_label,
    upgradeNoDiscount: translations.widget.upgrade_to_subscription_without_discount_label,
  };

  const tierProgressBarTranslations = translations.tier_progress_bar;
  const components = Rebuy.SmartCart.settings.components;
  const buyMoreSaveMore = Rebuy.SmartCart.settings.buy_more_save_more;
  const emptyCart = Rebuy.SmartCart.settings.empty_cart_markup;
  const switchToSubscription = Rebuy.SmartCart.settings.switch_to_subscription;
  const storefrontHelper = new ShopifyStorefrontHelper();

  if (smartCart && components) {
    components.forEach((component) => {
      switch (component.type) {
        case 'checkout': {
          const checkoutTranslation = {
            checkout_label: smartCart.checkout_label,
            view_cart_label: smartCart.view_cart_label,
            checking_out_label: smartCart.checking_out_label,
            view_cart_working_label: smartCart.view_cart_working_label,
            continue_shopping_label: smartCart.continue_shopping_label,
            terms_and_conditions_label: smartCart.terms_and_conditions_label,
          };
          Object.assign(component.settings.language, checkoutTranslation);
          break;
        }
        case 'custom_code_block': {
          const checkoutTranslation = smartCart.taxes_and_shipping_at_checkout;
          component.settings.html_code = decodeHTML(checkoutTranslation);
          break;
        }
        case 'cart_subtotal': {
          const cartSubtotalTranslation = {
            subtotal_plural_text: smartCart.subtotal_plural_text,
            subtotal_singular_text: smartCart.subtotal_singular_text,
          };
          Object.assign(component.settings, cartSubtotalTranslation);
          break;
        }
        case 'tiered_progress_bar': {
          const keys = [
            'free_shipping_reached',
            'free_shipping_remaining',
            'product_amount_reached_label_text',
            'product_amount_remaining_label_text',
            'discount_amount_remaining_label_text',
            'discount_amount_reached_label_text',
          ];

          const translationsMap = {};

          keys.forEach((key) => {
            translationsMap[key] = decodeHTML(tierProgressBarTranslations[key]);
          });

          const {
            free_shipping_reached: freeShippingReached,
            free_shipping_remaining: freeShippingRemaining,
            product_amount_reached_label_text: productAmountReachedLabelText,
            product_amount_remaining_label_text: productAmountRemainingLabelText,
            discount_amount_remaining_label_text: discountAmountRemainingLabelText,
            discount_amount_reached_label_text: discountAmountReachedLabelText,
          } = translationsMap;

          const progressBarTranslation = {
            free_shipping_reached: freeShippingReached,
            free_shipping_remaining: freeShippingRemaining,
            product_amount_reached_label_text: productAmountReachedLabelText,
            product_amount_remaining_label_text: productAmountRemainingLabelText,
            discount_amount_remaining_label_text: discountAmountRemainingLabelText,
            discount_amount_reached_label_text: discountAmountReachedLabelText,
          };
          if (component.settings.bars) {
            component.settings.bars.forEach((bar) => {
              Object.assign(bar.language, progressBarTranslation);
              bar.earnedProducts?.forEach((product) => {
                storefrontHelper.updateProductJSON(product);
              });
              bar.tiers.forEach((tier, index) => {
                if (tier.type !== 'shipping') {
                  Object.assign(tier, progressBarTranslation);
                }
                if (tier.type === 'product') {
                  storefrontHelper.updateProductJSON(tier.products[0]);
                }
                if (tier.type === 'shipping') {
                  document.querySelectorAll('.rebuy-cart__progress-step-label')[index]
                    ? (document.querySelectorAll('.rebuy-cart__progress-step-label')[
                        index
                      ].innerText = tierProgressBarTranslations.free_shipping)
                    : null;
                }
              });
            });
          }
          break;
        }
        case 'title_bar': {
          const titleBarTranslation = {
            title: smartCart.cart_title,
          };
          Object.assign(component.settings, titleBarTranslation);
          break;
        }
        case 'login': {
          const loginTranslation = {
            title: smartCart.login_title,
          };
          Object.assign(component.settings.language, loginTranslation);
          break;
        }
        case 'discount_code': {
          const discountCodeTranslation = {
            discount_code_label: smartCart.discount_code_label,
            discount_button_label: smartCart.discount_button_label,
            discount_invalid_message: smartCart.discount_invalid_message,
          };
          Object.assign(component.settings.language, discountCodeTranslation);
          break;
        }
        case 'notes': {
          const notesTranslation = {
            notes_label: smartCart.notes_label,
            notes_placeholder: smartCart.notes_placeholder,
            notes_remaining_characters: smartCart.notes_remaining_characters,
          };
          Object.assign(component.settings.language, notesTranslation);
          break;
        }
      }
    });
    // Handle 'buy_more_save_more' settings
    if (buyMoreSaveMore) {
      const bmsmTranslation = {
        bmsm_discount_message: smartCart.bmsm_discount_message,
        bmsm_discount_success: smartCart.bmsm_discount_success,
      };
      Object.assign(buyMoreSaveMore.language, bmsmTranslation);
    }
    // Handle 'empty cart' settings
    if (emptyCart) {
      const escapedHTML = smartCart.empty_cart_markup; // The escaped HTML string
      const emptyCartMarkUp = decodeHTML(escapedHTML);

      const emptyCartTranslation = {
        empty_cart_markup: emptyCartMarkUp,
      };

      Object.assign(Rebuy.SmartCart.settings, emptyCartTranslation);
    }
    if (switchToSubscription) {
      const subscriptionTranslation = {
        downgrading_label: subscriptionTranslations.downgrading_label,
        onetime_option_group_label: subscriptionTranslations.onetimeLabel,
        onetime_option_label: subscriptionTranslations.onetimeLabel,
        subscription_option_group_label: subscriptionTranslations.subscriptionLabel,
        upgrade_to_subscription_label: subscriptionTranslations.upgrade,
        upgrade_to_subscription_without_discount_label: subscriptionTranslations.upgradeNoDiscount,
        upgrading_label: subscriptionTranslations.upgradeLabel,
      };
      Object.assign(switchToSubscription.language, subscriptionTranslation);
    }
  }
};

updateWidgetLanguage = (widget) => {
  const locale = Shopify?.locale;

  const widgetTranslation = translations[widget.id];
  const globalTranslation = translations.widget;

  if (locale && widgetTranslation) {
    Object.assign(widget.data.settings.language, widgetTranslation);
    widget.compileConfig();
  } else if (locale && globalTranslation) {
    const globalTranslationParsed = decodeHTML(globalTranslation);
    Object.assign(widget.data.settings.language, globalTranslationParsed);

    widget.compileConfig();
  }
};

updateTierLanguage = () => {
  const giftTitle = document.querySelector('.rebuy-cart__progress-gifts-title');
  const variantPrompt = document.querySelectorAll(
    '.rebuy-cart__progress-gift-variant-select-prompt'
  );
  const firstOption = document.querySelectorAll(
    '.rebuy-cart__progress-gift-variant-select option[value=""]'
  );
  if (giftTitle) {
    giftTitle.textContent = translations.smart_cart.gift_title;
  }
  if (variantPrompt) {
    variantPrompt.forEach((prompt) => (prompt.textContent = translations.smart_cart.select_gift));
  }
  if (firstOption) {
    firstOption.forEach((prompt) => (prompt.textContent = translations.smart_cart.select_gift));
  }
};

updateAnnouncementBar = () => {
  const announcementTranslations = [
    translations.smart_cart.announcement_bar_1,
    translations.smart_cart.announcement_bar_2,
    translations.smart_cart.announcement_bar_3,
  ];
  const components = Rebuy.SmartCart.settings.components;
  if (announcementTranslations) {
    const announcementBars = components.filter((c) => c.type === 'announcement_bar');
    announcementBars.forEach((bar, index) => {
      announcementTranslations.forEach((translation, i) => {
        if (bar.settings.messages[i]) {
          bar.settings.messages[i] = translation;
        }
      });
    });
  }
};

// Update Smart Cart with locale translations
document.addEventListener('rebuy:smartcart.ready', () => {
  updateSmartCartLanguage();
  updateAnnouncementBar();
});

// Update widgets with locale translations
document.addEventListener('rebuy.ready', (event) => {
  const widget = event.detail.widget;
  updateWidgetLanguage(widget);
});


// Update free gifts text
document.addEventListener('rebuy:cart.change', (event) => {
  setTimeout(() => {
    try {
      if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.settings) {
        updateTierLanguage();
        updateSmartCartLanguage();
        updateAnnouncementBar();
      }
    } catch (e) {
      console.error('[rebuy-translation] error in tier/smart-cart/announcement updates:', e);
    }
  }, 0);

  // Update all theme cart icon bubbles - debounced so repeated
  // rebuy:cart.change events only trigger one update, and prefer Rebuy's
  // already-loaded cart state before falling back to /cart.js.
  clearTimeout(window._rebuyBubbleUpdateTimer);
  window._rebuyBubbleUpdateTimer = setTimeout(() => {
    try {
      const count = window.Rebuy?.SmartCart?.cart?.item_count;
      if (count !== undefined) {
        document.querySelectorAll('cart-icon-bubble').forEach((bubbleRoot) => {
          const countWrapper = bubbleRoot.querySelector('.cart-icon-bubble__count');
          const countEl = bubbleRoot.querySelector('.cart-count');
          if (!countWrapper || !countEl) return;
          countEl.textContent = count;
          countWrapper.classList.toggle('hidden', count === 0);
        });
      } else if (typeof window.updateThemeCartBubblesFromCart === 'function') {
        window.updateThemeCartBubblesFromCart();
      }
    } catch (e) {
      console.error('[rebuy-translation] error updating cart bubbles:', e);
    }
  }, 100);
});

// update product JSON every time products are loaded or changed
document.addEventListener('rebuy.productsChange', (e) => {
  const widget = e.detail.widget;
  const storefrontHelper = new ShopifyStorefrontHelper();

  // loop over products in the widget and enrich product json
  widget.data.products.forEach((product) => storefrontHelper.updateProductJSON(product));
});
